import React, { useEffect, useState, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";

import {
  get,
  checkResponse,
  checkHttpStatus,
} from "../../../modules/httpFunctions";
import Load from "../../app/generic/load";
import { error } from "../../../modules/messages";
import ServiceWithParameter from "./serviceWithParameter";
import { handleError } from "../../../modules/errorLogger";
import DateItem, { getDateFromDatePicker } from "../../app/generic/dateItem";
import { createQueryString, getEntity } from "../../../modules/crudOperations";

function ServiceWithDate({
  label,
  detail,
  delivery,
  disabled,
  productId,
  countryId,
  fieldName,
  fromToday,
  checkDate,
  getNearest,
  formItemLayout,
  getFieldDecorator,
  initialServiceDate,
}) {
  const intl = useIntl();
  const [showDate, setShowDate] = useState();
  const [initialDate, setInitialDate] = useState();
  const onLoad = useCallback(() => {
    if (initialServiceDate) {
      setInitialDate(moment(initialServiceDate));
    } else if (detail) {
      setShowDate(true);
      setInitialDate(null);
    } else if (getNearest) {
      getEntity(
        "consignment/nearest-pickup-date",
        undefined,
        undefined,
        (value) =>
          setInitialDate(value === "e" ? null : moment(value.pickupDate)),
        { countryId, productId }
      );
    } else {
      setShowDate(true);
      setInitialDate(null);
    }
  }, [detail, countryId, productId, getNearest, initialServiceDate]);
  const dateValidator = useCallback(
    (_rule, value, callback) => {
      if (value && checkDate) {
        get(
          `consignment/check-${
            delivery ? "delivery" : "pickup"
          }-date${createQueryString({
            date: getDateFromDatePicker(value),
            countryId,
            productId,
          })}`
        )
          .then((r) => {
            if (checkHttpStatus(r)) {
              callback(
                checkResponse(r) ? undefined : new Error(r.data.message)
              );
            } else {
              error(
                intl.formatMessage({
                  id: "consignment.services.dateCheckError",
                  defaultMessage: "Při kontrole data nastala chyba!",
                })
              );
              callback();
            }
          })
          .catch((err) => {
            error(
              intl.formatMessage({
                id: "consignment.services.dateCheckError",
                defaultMessage: "Při kontrole data nastala chyba!",
              })
            );
            handleError(err);
            callback();
          });
      } else {
        callback();
      }
    },
    [intl, countryId, delivery, productId, checkDate]
  );

  useEffect(() => {
    (!getNearest || (countryId && productId)) && onLoad();
  }, [onLoad, countryId, productId, getNearest]);

  return (
    <ServiceWithParameter label={label} wrapperSpan={12}>
      {initialDate || showDate ? (
        <DateItem
          optional
          disabled={disabled}
          fieldName={fieldName}
          fromToday={fromToday}
          initialDate={initialDate}
          onValidation={dateValidator}
          className="service-form-date"
          formItemLayout={formItemLayout}
          getFieldDecorator={getFieldDecorator}
        />
      ) : (
        <Load
          size="small"
          message={
            !countryId && (
              <FormattedMessage
                id="consignment.services.dateCheck.country"
                defaultMessage="Vyberte prosím zemi svozu"
              />
            )
          }
        />
      )}
    </ServiceWithParameter>
  );
}

export default ServiceWithDate;
